import { Card, Status } from "@allergy123/ui";
import { Link } from "react-router";
import { SkinTestingProficiencyCalculator } from "../features/skin-testing-proficiency/Calculator";

export function SkinTestingProficiencyPage() {
  return (
    <>
      <nav aria-label="Breadcrumb" className="mb-4 text-small text-ink-secondary">
        <Link to="/training">Training</Link> · Skin testing proficiency
      </nav>

      <header className="mb-8">
        <p className="mb-2 text-small font-medium uppercase tracking-wide text-ink-secondary">Allergy Technician · practice tool</p>
        <h1 className="mb-3 text-h1 font-semibold text-anchor">Skin testing proficiency calculator</h1>
        <p className="max-w-[72ch] text-ink-secondary">
          Enter valid, evaluator-recorded measurements from the 10 histamine and 10 matched-negative-control exercise. The page calculates the control-response standards; it does not replace the evaluator's procedural rubric.
        </p>
      </header>

      <Card tone="tinted" className="mb-8">
        <Status kind="warning" label="Draft method — clinical and operations approval pending" className="mb-4" />
        <div className="grid gap-4 md:grid-cols-3">
          <div>
            <p className="text-small font-medium text-ink-secondary">Site mean</p>
            <p className="mt-1 font-semibold text-anchor">(D + d) ÷ 2</p>
          </div>
          <div>
            <p className="text-small font-medium text-ink-secondary">Histamine</p>
            <p className="mt-1 font-semibold text-anchor">Sample CV &lt;30%</p>
          </div>
          <div>
            <p className="text-small font-medium text-ink-secondary">Every negative site</p>
            <p className="mt-1 font-semibold text-anchor">Wheal &lt;3 mm · flare &lt;10 mm</p>
          </div>
        </div>
        <p className="mt-4 text-small text-ink-secondary">
          All thresholds use unrounded calculations. Exactly 30%, 3 mm, or 10 mm does not meet the corresponding strict limit. The reaction-recording procedure is outside this page.
        </p>
      </Card>

      <SkinTestingProficiencyCalculator />

      <section className="mt-12 border-t border-rule-subtle pt-8" aria-labelledby="method-heading">
        <h2 id="method-heading" className="mb-3 text-h2 font-semibold text-anchor">Method and sources</h2>
        <p className="mb-4 max-w-[72ch] text-ink-secondary">
          The calculation uses sample standard deviation because the AAAAI teaching deck's worked method divides by one less than the number of measurements. Missing or invalid sites are never dropped, and a zero histamine mean makes CV mathematically undefined.
        </p>
        <ul className="list-disc space-y-2 pl-5 text-small text-ink-secondary">
          <li><a href="https://www.aaaai.org/Aaaai/media/MediaLibrary/PDF%20Documents/Practice%20and%20Parameters/allergydiagnostictesting.pdf" target="_blank" rel="noreferrer">AAAAI/ACAAI Allergy Diagnostic Testing practice parameter, Table 3</a></li>
          <li><a href="https://education.aaaai.org/sites/default/files/Dowling.pdf" target="_blank" rel="noreferrer">AAAAI procedural competency demonstration, slides 9–16</a></li>
          <li><a href="https://doi.org/10.1016/S1081-1206(10)60895-2" target="_blank" rel="noreferrer">Oppenheimer and Nelson, Skin Testing</a></li>
        </ul>
        <p className="mt-4 text-small text-ink-secondary">Calculation method v0.1.0 · source-reviewed September 15, 2026 · no data saved</p>
      </section>
    </>
  );
}
